<template>
  <el-container
    style="
      display: flex;
      justify-content: center;
      margin: 5vh 5vw;
      max-height: 90vh;
      overflow-y: auto;
      overflow-x: hidden;
    "
  >
    <el-card
      style="width: 700px; height: 590px"
      body-style="display: flex; flex-direction: column; justify-content:center; align-items: center; padding: 0"
    >
      <img
        class="img"
        src="../assets/Final Logo Transparent 2.svg"
        style="
          object-fit: cover;
          width: 300px;
          height: 200px;
          object-position: left center;
          margin: 50px 0 -40px 0;
        "
      />
      <div
        style="
          margin-top: 20px;
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        "
      >
        <el-form @submit.native.prevent="login">
          <el-input
            placeholder="Email Address"
            v-model="$v.email.$model"
            ref="email"
            type="email"
            :class="{ error: checkValid && $v.email.$invalid }"
            style="margin: 15px 0"
          />
          <el-input
            placeholder="Password"
            type="password"
            v-model="$v.password.$model"
            show-password
            :class="{ error: checkValid && $v.password.$invalid }"
          />
          <el-button
            class="button"
            style="width: 100%; margin: 40px 0 15px 0"
            native-type="submit"
            >Log In</el-button
          >
        </el-form>
        <!-- <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                    "
                > -->
        <div style="display: flex; justify-content: flex-end; width: 100%">
          <!-- <div>
                        <el-link @click="requestAccess" type="primary" disabled
                            >Request Access</el-link
                        >
                    </div> -->
          <div>
            <el-link @click="forgotPassword" type="primary"
              >Reset Password</el-link
            >
          </div>
        </div>
      </div>
    </el-card>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import AuthenticationService from "../services/AuthenticationService";
import {
  required,
  email,
  alphaNum,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import Helper from "../utilities/Helper";

/**
 * @vue-data {String} [email=null] - Current user's email address
 * @vue-data {String} [password=null] - Current user's password
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 */
export default {
  data() {
    return {
      email: null,
      password: null,
      checkValid: false,
    };
  },
  computed: {
    ...mapState(["isUserLoggedIn"]),
  },
  methods: {
    handleError: Helper.handleError,
    /**
     * Sends the admin an emial requesting access to DataMaestro
     * @async
     * @function
     */
    async requestAccess() {
      console.log("request access");
    },
    /**
     * Sends the user a password reset email
     * @async
     * @function
     */
    async forgotPassword() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        await AuthenticationService.forgotPassword({
          email: this.email,
        });
        this.$message({
          type: "success",
          message:
            "An email has been sent to reset your password if an account with this email address exists.",
          duration: 5000,
          showClose: true,
        });
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
    /**
     * Logs the user into the app
     * @async
     * @function
     */
    async login() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.checkValid = true;
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password,
        });

        if (response.data.samlLoginURL) {
          console.log("Hello....");
          window.location.replace(response.data.samlLoginURL);
          return;
        } else {
          // this.$store.dispatch("setToken", response.data.token);
          this.$store.dispatch("setUserId", response.data.userId);
          this.$store.dispatch("setUserRole", response.data.userRole);
          this.$store.dispatch(
            "setOrganizationId",
            response.data.organizationId
          );

          this.$router.push({ name: "environments" });
        }
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
  },
  mounted() {
    if (this.isUserLoggedIn) {
      this.$router.push({ name: "servers" });
    } else {
      this.$refs.email.focus();
    }
  },
  validations() {
    return {
      email: { required, email },
      password: {
        required,
        alphaNum,
        minLength: minLength(8),
        maxLength: maxLength(32),
      },
    };
  },
};
</script>

<style scoped>
.el-link.is-underline:hover:after {
  border-bottom: none;
}
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
</style>
